// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-media-files-dialog__paper {
  max-height: min(92dvh, calc(100dvh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px))) !important;
}

.session-media-files-dialog__title {
  padding-top: max(16px, env(safe-area-inset-top, 0px)) !important;
  padding-right: max(12px, env(safe-area-inset-right, 0px)) !important;
  padding-left: max(16px, env(safe-area-inset-left, 0px)) !important;
}

.session-media-files-dialog__title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.session-media-files-dialog__title-text {
  min-width: 0;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.session-media-files-dialog__title-main {
  display: block;
  font-size: 1.15rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.session-media-files-dialog__close {
  flex-shrink: 0 !important;
  margin-top: -2px !important;
  color: inherit !important;
  background: rgba(120, 120, 128, 0.14) !important;
}

.session-media-files-dialog__close:hover {
  background: rgba(120, 120, 128, 0.26) !important;
}

.session-media-files-dialog__subtitle {
  display: block;
  margin-top: 0;
  font-size: 13px;
  font-weight: 500;
  opacity: 0.75;
  line-height: 1.35;
}

@media (max-width: 599px) {
  .session-media-files-dialog .MuiDialog-container {
    align-items: stretch !important;
  }

  .session-media-files-dialog__paper {
    margin: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    max-height: 100dvh !important;
    height: 100dvh !important;
    border-radius: 0 !important;
  }

  .session-media-files-dialog__title {
    padding-top: max(14px, env(safe-area-inset-top, 0px)) !important;
  }

  .session-media-files-dialog .MuiDialogContent-root {
    padding-bottom: max(16px, env(safe-area-inset-bottom, 0px)) !important;
  }
}

.session-media-files-dialog__filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 4px 0 14px;
}

.session-media-files-dialog__chip {
  appearance: none;
  border: 1px solid rgba(128, 128, 128, 0.35);
  background: rgba(128, 128, 128, 0.08);
  color: inherit;
  border-radius: 999px;
  padding: 7px 12px;
  font-size: 13px;
  font-weight: 650;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition:
    background 0.2s cubic-bezier(0.25, 1, 0.5, 1),
    border-color 0.2s cubic-bezier(0.25, 1, 0.5, 1),
    transform 0.15s cubic-bezier(0.25, 1, 0.5, 1);
}

.session-media-files-dialog__chip:hover {
  background: rgba(128, 128, 128, 0.14);
}

.session-media-files-dialog__chip:active {
  transform: scale(0.97);
}

.session-media-files-dialog__chip.is-selected {
  border-color: rgba(10, 132, 255, 0.55);
  background: rgba(10, 132, 255, 0.16);
}

.session-media-files-dialog__chip:focus-visible {
  outline: 2px solid rgba(10, 132, 255, 0.55);
  outline-offset: 2px;
}

.session-media-files-dialog__import {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0 0 14px;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid rgba(128, 128, 128, 0.28);
  background: rgba(128, 128, 128, 0.08);
}

.session-media-files-dialog__import-label {
  font-size: 13px;
  font-weight: 700;
}

.session-media-files-dialog__import-select {
  appearance: none;
  width: 100%;
  border: 1px solid rgba(128, 128, 128, 0.4);
  background: var(--surface-color, #fff);
  color: inherit;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 600;
}

.session-media-files-dialog__import-hint,
.session-media-files-dialog__import-status {
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
  opacity: 0.78;
}

.session-media-files-dialog__chip-count {
  font-size: 11px;
  font-weight: 700;
  opacity: 0.7;
  min-width: 1.25em;
  text-align: center;
}

.session-media-files-dialog__batch-actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0 0 14px;
}

.session-media-files-dialog__batch-btn {
  appearance: none;
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid rgba(10, 132, 255, 0.45);
  background: rgba(10, 132, 255, 0.14);
  color: inherit;
  border-radius: 12px;
  padding: 11px 14px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition:
    background 0.2s cubic-bezier(0.25, 1, 0.5, 1),
    border-color 0.2s cubic-bezier(0.25, 1, 0.5, 1),
    transform 0.15s cubic-bezier(0.25, 1, 0.5, 1),
    opacity 0.15s ease;
}

.session-media-files-dialog__batch-btn:hover:not(:disabled) {
  background: rgba(10, 132, 255, 0.22);
}

.session-media-files-dialog__batch-btn:active:not(:disabled) {
  transform: scale(0.985);
}

.session-media-files-dialog__batch-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.session-media-files-dialog__batch-btn:focus-visible {
  outline: 2px solid rgba(10, 132, 255, 0.55);
  outline-offset: 2px;
}

.session-media-files-dialog__batch-hint {
  margin: 0;
  font-size: 12px;
  line-height: 1.35;
  opacity: 0.72;
  font-weight: 500;
}

.session-media-files-dialog__busy-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 12px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(10, 132, 255, 0.1);
  border: 1px solid rgba(10, 132, 255, 0.22);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.35;
}

.session-media-files-dialog__state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 140px;
  text-align: center;
  opacity: 0.85;
  font-size: 14px;
}

.session-media-files-dialog__state--error {
  color: #ef4444;
  opacity: 1;
}

.session-media-files-dialog__status {
  margin: 0 0 12px;
  padding: 10px 12px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.35;
}

.session-media-files-dialog__status--ok {
  background: rgba(52, 199, 89, 0.14);
  border: 1px solid rgba(52, 199, 89, 0.35);
}

.session-media-files-dialog__status--error {
  background: rgba(239, 68, 68, 0.12);
  border: 1px solid rgba(239, 68, 68, 0.35);
  color: #ef4444;
}

.session-media-files-dialog__cards {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.session-media-files-dialog__return {
  position: sticky;
  top: 0;
  z-index: 2;
  margin: 0 0 6px;
  padding: 7px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 650;
  letter-spacing: -0.01em;
  line-height: 1.35;
  color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color, #fff));
  box-shadow: 0 1px 0 color-mix(in srgb, var(--brand-primary, #0877bc) 18%, transparent);
}

.session-media-clip {
  --sm-clip-accent: var(--brand-primary, #0877bc);
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) auto;
  grid-template-areas: "play body tools";
  align-items: center;
  column-gap: 10px;
  row-gap: 6px;
  margin: 0;
  padding: 7px 8px 7px 7px;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--text-color, #1c1c1e) 12%, transparent);
  background: var(--surface-color, #fff);
  box-shadow: none;
  scroll-margin-top: 44px;
  scroll-margin-bottom: 12px;
  transition:
    border-color 0.18s ease,
    background 0.18s ease,
    box-shadow 0.18s ease;
}

.session-media-clip:hover {
  border-color: color-mix(in srgb, var(--sm-clip-accent) 36%, transparent);
  background: color-mix(in srgb, var(--sm-clip-accent) 4%, var(--surface-color, #fff));
}

.session-media-clip--processing {
  border-color: color-mix(in srgb, var(--sm-clip-accent) 42%, transparent);
}

.session-media-clip--last {
  border-color: color-mix(in srgb, var(--sm-clip-accent) 50%, transparent);
  background: color-mix(in srgb, var(--sm-clip-accent) 8%, var(--surface-color, #fff));
  box-shadow: inset 3px 0 0 var(--sm-clip-accent);
}

.session-media-clip--return {
  animation: session-media-clip-return 1.5s cubic-bezier(0.22, 1, 0.36, 1);
}

.session-media-clip__play {
  grid-area: play;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 10px;
  background: color-mix(in srgb, var(--sm-clip-accent) 13%, transparent);
  color: var(--sm-clip-accent);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;
}

.session-media-clip:hover .session-media-clip__play,
.session-media-clip__play:hover {
  background: var(--sm-clip-accent);
  color: #fff;
}

.session-media-clip--last .session-media-clip__play {
  background: var(--sm-clip-accent);
  color: #fff;
}

.session-media-clip__play:active:not(:disabled) {
  transform: scale(0.96);
}

.session-media-clip__play:disabled {
  cursor: default;
  opacity: 0.5;
}

.session-media-clip__play:focus-visible,
.session-media-clip__tools .player-exercise-details__move-video-icon-btn:focus-visible {
  outline: 2px solid var(--sm-clip-accent);
  outline-offset: 2px;
}

.session-media-clip__body {
  grid-area: body;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  min-width: 0;
  margin: 0;
  padding: 1px 0;
  cursor: pointer;
}

.session-media-clip__title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
}

.session-media-clip__title {
  min-width: 0;
  flex: 1 1 8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 650;
  letter-spacing: -0.015em;
  line-height: 1.25;
  color: var(--text-color, inherit);
}

.session-media-clip__kind,
.session-media-clip__watched {
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 750;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  line-height: 1;
  padding: 3px 6px;
  border-radius: 999px;
}

.session-media-clip__kind {
  background: color-mix(in srgb, var(--sm-clip-accent) 14%, transparent);
  color: var(--sm-clip-accent);
}

.session-media-clip[data-kind="kot"] {
  --sm-clip-accent: #c77700;
}

.session-media-clip[data-kind="replay"] {
  --sm-clip-accent: #475569;
}

.session-media-clip[data-kind="reel"] {
  --sm-clip-accent: #c2185b;
}

.session-media-clip__watched {
  letter-spacing: 0.02em;
  text-transform: none;
  font-weight: 700;
  color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 14%, transparent);
}

.session-media-clip__meta,
.session-media-clip__roles {
  display: block;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11.5px;
  line-height: 1.3;
  font-weight: 500;
  color: var(--text-secondary, #6b6b6b);
}

.session-media-clip__roles {
  font-weight: 600;
  color: var(--text-color, inherit);
  opacity: 0.78;
}

.session-media-clip__tools {
  grid-area: tools;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  flex-wrap: wrap;
  max-width: 132px;
}

.session-media-clip__tools .player-exercise-details__move-video-icon-btn {
  width: 28px !important;
  height: 28px !important;
  border-radius: 8px !important;
  border-color: color-mix(in srgb, var(--text-color, #111) 12%, transparent) !important;
  background: color-mix(in srgb, var(--text-color, #111) 5%, var(--surface-color, #fff)) !important;
  color: var(--text-secondary, #5c5c5c) !important;
}

.session-media-clip__tools .player-exercise-details__move-video-icon-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--sm-clip-accent) 12%, var(--surface-color, #fff)) !important;
  color: var(--sm-clip-accent) !important;
  border-color: color-mix(in srgb, var(--sm-clip-accent) 28%, transparent) !important;
}

.session-media-clip:has(.session-media-clip__job) {
  grid-template-areas:
    "play body tools"
    "job job job";
}

.session-media-clip__job {
  grid-area: job;
}

@media (max-width: 520px) {
  .session-media-clip {
    grid-template-columns: 36px minmax(0, 1fr);
    grid-template-areas:
      "play body"
      "tools tools";
    padding-bottom: 8px;
  }

  .session-media-clip:has(.session-media-clip__job) {
    grid-template-areas:
      "play body"
      "tools tools"
      "job job";
  }

  .session-media-clip__tools {
    max-width: none;
    justify-content: flex-end;
  }
}

@media (prefers-reduced-motion: reduce) {
  .session-media-clip,
  .session-media-clip__play {
    transition: none;
  }

  .session-media-clip--return {
    animation: none;
  }
}

@keyframes session-media-clip-return {
  0% {
    box-shadow:
      inset 3px 0 0 var(--sm-clip-accent),
      0 0 0 0 color-mix(in srgb, var(--sm-clip-accent) 42%, transparent);
  }
  50% {
    box-shadow:
      inset 3px 0 0 var(--sm-clip-accent),
      0 0 0 6px color-mix(in srgb, var(--sm-clip-accent) 0%, transparent);
  }
  100% {
    box-shadow: inset 3px 0 0 var(--sm-clip-accent);
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/SessionMediaFilesDialog.css"],"names":[],"mappings":"AAAA;EACE,kHAAkH;AACpH;;AAEA;EACE,gEAAgE;EAChE,oEAAoE;EACpE,kEAAkE;AACpE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,0BAA0B;IAC1B,6BAA6B;IAC7B,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,gEAAgE;EAClE;;EAEA;IACE,sEAAsE;EACxE;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR;;;iDAG+C;AACjD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,sCAAsC;EACtC,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0CAA0C;EAC1C,oCAAoC;EACpC,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;;;sBAIoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,oCAAoC;EACpC,6FAA6F;EAC7F,sFAAsF;AACxF;;AAEA;EACE,+CAA+C;EAC/C,aAAa;EACb,+CAA+C;EAC/C,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,mBAAmB;EACnB,iFAAiF;EACjF,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B;;;yBAGuB;AACzB;;AAEA;EACE,wEAAwE;EACxE,oFAAoF;AACtF;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,wEAAwE;EACxE,oFAAoF;EACpF,+CAA+C;AACjD;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,sEAAsE;EACtE,4BAA4B;EAC5B,eAAe;EACf,yEAAyE;AAC3E;;AAEA;;EAEE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sEAAsE;EACtE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,oCAAoC;EACpC,8EAA8E;AAChF;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,qFAAqF;EACrF,iGAAiG;EACjG,gDAAgD;AAClD;;AAEA;EACE,gGAAgG;EAChG,uCAAuC;EACvC,mFAAmF;AACrF;;AAEA;EACE;;iBAEe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,0CAA0C;IAC1C;;mBAEe;IACf,mBAAmB;EACrB;;EAEA;IACE;;;eAGW;EACb;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE;;wEAEoE;EACtE;EACA;IACE;;yEAEqE;EACvE;EACA;IACE,+CAA+C;EACjD;AACF","sourcesContent":[".session-media-files-dialog__paper {\n  max-height: min(92dvh, calc(100dvh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px))) !important;\n}\n\n.session-media-files-dialog__title {\n  padding-top: max(16px, env(safe-area-inset-top, 0px)) !important;\n  padding-right: max(12px, env(safe-area-inset-right, 0px)) !important;\n  padding-left: max(16px, env(safe-area-inset-left, 0px)) !important;\n}\n\n.session-media-files-dialog__title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.session-media-files-dialog__title-text {\n  min-width: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.session-media-files-dialog__title-main {\n  display: block;\n  font-size: 1.15rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n}\n\n.session-media-files-dialog__close {\n  flex-shrink: 0 !important;\n  margin-top: -2px !important;\n  color: inherit !important;\n  background: rgba(120, 120, 128, 0.14) !important;\n}\n\n.session-media-files-dialog__close:hover {\n  background: rgba(120, 120, 128, 0.26) !important;\n}\n\n.session-media-files-dialog__subtitle {\n  display: block;\n  margin-top: 0;\n  font-size: 13px;\n  font-weight: 500;\n  opacity: 0.75;\n  line-height: 1.35;\n}\n\n@media (max-width: 599px) {\n  .session-media-files-dialog .MuiDialog-container {\n    align-items: stretch !important;\n  }\n\n  .session-media-files-dialog__paper {\n    margin: 0 !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    max-height: 100dvh !important;\n    height: 100dvh !important;\n    border-radius: 0 !important;\n  }\n\n  .session-media-files-dialog__title {\n    padding-top: max(14px, env(safe-area-inset-top, 0px)) !important;\n  }\n\n  .session-media-files-dialog .MuiDialogContent-root {\n    padding-bottom: max(16px, env(safe-area-inset-bottom, 0px)) !important;\n  }\n}\n\n.session-media-files-dialog__filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 4px 0 14px;\n}\n\n.session-media-files-dialog__chip {\n  appearance: none;\n  border: 1px solid rgba(128, 128, 128, 0.35);\n  background: rgba(128, 128, 128, 0.08);\n  color: inherit;\n  border-radius: 999px;\n  padding: 7px 12px;\n  font-size: 13px;\n  font-weight: 650;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition:\n    background 0.2s cubic-bezier(0.25, 1, 0.5, 1),\n    border-color 0.2s cubic-bezier(0.25, 1, 0.5, 1),\n    transform 0.15s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n.session-media-files-dialog__chip:hover {\n  background: rgba(128, 128, 128, 0.14);\n}\n\n.session-media-files-dialog__chip:active {\n  transform: scale(0.97);\n}\n\n.session-media-files-dialog__chip.is-selected {\n  border-color: rgba(10, 132, 255, 0.55);\n  background: rgba(10, 132, 255, 0.16);\n}\n\n.session-media-files-dialog__chip:focus-visible {\n  outline: 2px solid rgba(10, 132, 255, 0.55);\n  outline-offset: 2px;\n}\n\n.session-media-files-dialog__import {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 0 0 14px;\n  padding: 12px;\n  border-radius: 12px;\n  border: 1px solid rgba(128, 128, 128, 0.28);\n  background: rgba(128, 128, 128, 0.08);\n}\n\n.session-media-files-dialog__import-label {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.session-media-files-dialog__import-select {\n  appearance: none;\n  width: 100%;\n  border: 1px solid rgba(128, 128, 128, 0.4);\n  background: var(--surface-color, #fff);\n  color: inherit;\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.session-media-files-dialog__import-hint,\n.session-media-files-dialog__import-status {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.4;\n  opacity: 0.78;\n}\n\n.session-media-files-dialog__chip-count {\n  font-size: 11px;\n  font-weight: 700;\n  opacity: 0.7;\n  min-width: 1.25em;\n  text-align: center;\n}\n\n.session-media-files-dialog__batch-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 0 0 14px;\n}\n\n.session-media-files-dialog__batch-btn {\n  appearance: none;\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: 1px solid rgba(10, 132, 255, 0.45);\n  background: rgba(10, 132, 255, 0.14);\n  color: inherit;\n  border-radius: 12px;\n  padding: 11px 14px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition:\n    background 0.2s cubic-bezier(0.25, 1, 0.5, 1),\n    border-color 0.2s cubic-bezier(0.25, 1, 0.5, 1),\n    transform 0.15s cubic-bezier(0.25, 1, 0.5, 1),\n    opacity 0.15s ease;\n}\n\n.session-media-files-dialog__batch-btn:hover:not(:disabled) {\n  background: rgba(10, 132, 255, 0.22);\n}\n\n.session-media-files-dialog__batch-btn:active:not(:disabled) {\n  transform: scale(0.985);\n}\n\n.session-media-files-dialog__batch-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.session-media-files-dialog__batch-btn:focus-visible {\n  outline: 2px solid rgba(10, 132, 255, 0.55);\n  outline-offset: 2px;\n}\n\n.session-media-files-dialog__batch-hint {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.35;\n  opacity: 0.72;\n  font-weight: 500;\n}\n\n.session-media-files-dialog__busy-banner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0 0 12px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: rgba(10, 132, 255, 0.1);\n  border: 1px solid rgba(10, 132, 255, 0.22);\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n.session-media-files-dialog__state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  min-height: 140px;\n  text-align: center;\n  opacity: 0.85;\n  font-size: 14px;\n}\n\n.session-media-files-dialog__state--error {\n  color: #ef4444;\n  opacity: 1;\n}\n\n.session-media-files-dialog__status {\n  margin: 0 0 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n.session-media-files-dialog__status--ok {\n  background: rgba(52, 199, 89, 0.14);\n  border: 1px solid rgba(52, 199, 89, 0.35);\n}\n\n.session-media-files-dialog__status--error {\n  background: rgba(239, 68, 68, 0.12);\n  border: 1px solid rgba(239, 68, 68, 0.35);\n  color: #ef4444;\n}\n\n.session-media-files-dialog__cards {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.session-media-files-dialog__return {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  margin: 0 0 6px;\n  padding: 7px 10px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 650;\n  letter-spacing: -0.01em;\n  line-height: 1.35;\n  color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color, #fff));\n  box-shadow: 0 1px 0 color-mix(in srgb, var(--brand-primary, #0877bc) 18%, transparent);\n}\n\n.session-media-clip {\n  --sm-clip-accent: var(--brand-primary, #0877bc);\n  display: grid;\n  grid-template-columns: 36px minmax(0, 1fr) auto;\n  grid-template-areas: \"play body tools\";\n  align-items: center;\n  column-gap: 10px;\n  row-gap: 6px;\n  margin: 0;\n  padding: 7px 8px 7px 7px;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--text-color, #1c1c1e) 12%, transparent);\n  background: var(--surface-color, #fff);\n  box-shadow: none;\n  scroll-margin-top: 44px;\n  scroll-margin-bottom: 12px;\n  transition:\n    border-color 0.18s ease,\n    background 0.18s ease,\n    box-shadow 0.18s ease;\n}\n\n.session-media-clip:hover {\n  border-color: color-mix(in srgb, var(--sm-clip-accent) 36%, transparent);\n  background: color-mix(in srgb, var(--sm-clip-accent) 4%, var(--surface-color, #fff));\n}\n\n.session-media-clip--processing {\n  border-color: color-mix(in srgb, var(--sm-clip-accent) 42%, transparent);\n}\n\n.session-media-clip--last {\n  border-color: color-mix(in srgb, var(--sm-clip-accent) 50%, transparent);\n  background: color-mix(in srgb, var(--sm-clip-accent) 8%, var(--surface-color, #fff));\n  box-shadow: inset 3px 0 0 var(--sm-clip-accent);\n}\n\n.session-media-clip--return {\n  animation: session-media-clip-return 1.5s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.session-media-clip__play {\n  grid-area: play;\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--sm-clip-accent) 13%, transparent);\n  color: var(--sm-clip-accent);\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;\n}\n\n.session-media-clip:hover .session-media-clip__play,\n.session-media-clip__play:hover {\n  background: var(--sm-clip-accent);\n  color: #fff;\n}\n\n.session-media-clip--last .session-media-clip__play {\n  background: var(--sm-clip-accent);\n  color: #fff;\n}\n\n.session-media-clip__play:active:not(:disabled) {\n  transform: scale(0.96);\n}\n\n.session-media-clip__play:disabled {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.session-media-clip__play:focus-visible,\n.session-media-clip__tools .player-exercise-details__move-video-icon-btn:focus-visible {\n  outline: 2px solid var(--sm-clip-accent);\n  outline-offset: 2px;\n}\n\n.session-media-clip__body {\n  grid-area: body;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  min-width: 0;\n  margin: 0;\n  padding: 1px 0;\n  cursor: pointer;\n}\n\n.session-media-clip__title-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.session-media-clip__title {\n  min-width: 0;\n  flex: 1 1 8rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: 650;\n  letter-spacing: -0.015em;\n  line-height: 1.25;\n  color: var(--text-color, inherit);\n}\n\n.session-media-clip__kind,\n.session-media-clip__watched {\n  flex-shrink: 0;\n  font-size: 10px;\n  font-weight: 750;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  line-height: 1;\n  padding: 3px 6px;\n  border-radius: 999px;\n}\n\n.session-media-clip__kind {\n  background: color-mix(in srgb, var(--sm-clip-accent) 14%, transparent);\n  color: var(--sm-clip-accent);\n}\n\n.session-media-clip[data-kind=\"kot\"] {\n  --sm-clip-accent: #c77700;\n}\n\n.session-media-clip[data-kind=\"replay\"] {\n  --sm-clip-accent: #475569;\n}\n\n.session-media-clip[data-kind=\"reel\"] {\n  --sm-clip-accent: #c2185b;\n}\n\n.session-media-clip__watched {\n  letter-spacing: 0.02em;\n  text-transform: none;\n  font-weight: 700;\n  color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 14%, transparent);\n}\n\n.session-media-clip__meta,\n.session-media-clip__roles {\n  display: block;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 11.5px;\n  line-height: 1.3;\n  font-weight: 500;\n  color: var(--text-secondary, #6b6b6b);\n}\n\n.session-media-clip__roles {\n  font-weight: 600;\n  color: var(--text-color, inherit);\n  opacity: 0.78;\n}\n\n.session-media-clip__tools {\n  grid-area: tools;\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  flex-wrap: wrap;\n  max-width: 132px;\n}\n\n.session-media-clip__tools .player-exercise-details__move-video-icon-btn {\n  width: 28px !important;\n  height: 28px !important;\n  border-radius: 8px !important;\n  border-color: color-mix(in srgb, var(--text-color, #111) 12%, transparent) !important;\n  background: color-mix(in srgb, var(--text-color, #111) 5%, var(--surface-color, #fff)) !important;\n  color: var(--text-secondary, #5c5c5c) !important;\n}\n\n.session-media-clip__tools .player-exercise-details__move-video-icon-btn:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--sm-clip-accent) 12%, var(--surface-color, #fff)) !important;\n  color: var(--sm-clip-accent) !important;\n  border-color: color-mix(in srgb, var(--sm-clip-accent) 28%, transparent) !important;\n}\n\n.session-media-clip:has(.session-media-clip__job) {\n  grid-template-areas:\n    \"play body tools\"\n    \"job job job\";\n}\n\n.session-media-clip__job {\n  grid-area: job;\n}\n\n@media (max-width: 520px) {\n  .session-media-clip {\n    grid-template-columns: 36px minmax(0, 1fr);\n    grid-template-areas:\n      \"play body\"\n      \"tools tools\";\n    padding-bottom: 8px;\n  }\n\n  .session-media-clip:has(.session-media-clip__job) {\n    grid-template-areas:\n      \"play body\"\n      \"tools tools\"\n      \"job job\";\n  }\n\n  .session-media-clip__tools {\n    max-width: none;\n    justify-content: flex-end;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .session-media-clip,\n  .session-media-clip__play {\n    transition: none;\n  }\n\n  .session-media-clip--return {\n    animation: none;\n  }\n}\n\n@keyframes session-media-clip-return {\n  0% {\n    box-shadow:\n      inset 3px 0 0 var(--sm-clip-accent),\n      0 0 0 0 color-mix(in srgb, var(--sm-clip-accent) 42%, transparent);\n  }\n  50% {\n    box-shadow:\n      inset 3px 0 0 var(--sm-clip-accent),\n      0 0 0 6px color-mix(in srgb, var(--sm-clip-accent) 0%, transparent);\n  }\n  100% {\n    box-shadow: inset 3px 0 0 var(--sm-clip-accent);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
